<div class="flex justify-between">
  <p class="text-sm">
    {{ rangeText }}
  </p>

  <div class="flex items-center gap-2">

    <button (click)="prev()" [disabled]="!canPrev"
      class="flex h-6 w-6 items-center justify-center rounded-lg border border-grey-200 rotate-180 disabled:opacity-50">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.94141 13.2787L10.2881 8.93208C10.8014 8.41875 10.8014 7.57875 10.2881 7.06542L5.94141 2.71875"
          stroke="#253A81" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <button (click)="next()" [disabled]="!canNext"
      class="cursor-pointer flex h-6 w-6 items-center justify-center rounded-lg border border-grey-200 disabled:opacity-50">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.94141 13.2787L10.2881 8.93208C10.8014 8.41875 10.8014 7.57875 10.2881 7.06542L5.94141 2.71875"
          stroke="#253A81" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <span class="text-xs text-slate-500">{{ pageIndex + 1 }} out of {{ totalPages }}</span>
  </div>
</div>